var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBounce(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#4b4495;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Your_Bounces-2",
    "data-name": "Your Bounces-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29286",
    "data-name": "Path 29286",
    className: "cls-1",
    d: "M0,0H24V24H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29287",
    "data-name": "Path 29287",
    className: "cls-2",
    d: "M12.21,6.67c1.76,0,2.42.85,2.48,2.08h2.18A3.94,3.94,0,0,0,13.7,5V2.81h-3V5a5.16,5.16,0,0,0-1.09.36L11.13,6.8a5,5,0,0,1,1.08-.13Zm-7-2.95-1.4,1.4,3.41,3.4c0,2.06,1.54,3.19,3.87,3.88l3.48,3.47a2.72,2.72,0,0,1-2.4.9c-2,0-2.84-.91-3-2.08H7.08c.12,2.17,1.75,3.39,3.65,3.79v2.15h3V18.5a4.92,4.92,0,0,0,2.43-1.11l2.2,2.2,1.4-1.4Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBounce);
export default __webpack_public_path__ + "static/media/Bounce.1757759256b9311e11df62c9dbd9a053.svg";
export { ForwardRef as ReactComponent };